import { CampaignTemplate, TemplateTag } from './template.model';
import {
  FourSideStylingEntity,
  Widget,
  WidgetComponentType,
  WidgetContainer,
  WidgetLayout,
  WidgetPosition,
  WidgetState,
} from '../widgets.model';

export default class CampaignTemplateHelpers {
  static getDefaultStatePositionFromWidgetLayoutAndStateType(
    currentState: WidgetState,
    stateType: WidgetComponentType,
  ) {
    // For centered and fullscreen widgets we want position of teaser to always be bottom right, else we use current states position
    const bottomRightPositions = [WidgetPosition.Center, WidgetPosition.Fullscreen];
    if (bottomRightPositions.includes(currentState.position) && stateType === WidgetComponentType.Teaser) {
      return WidgetPosition.BottomRight;
    }
    return currentState.position;
  }

  static getDefaultContainer(order: number): WidgetContainer {
    const container = {
      type: WidgetComponentType.ContainerRegular,
      percentWidth: 100,
      hideOnMobile: false,
      hideOnDesktop: false,
      order: order,
      padding: { roundValue: '16px' } as FourSideStylingEntity,
    } as WidgetContainer;
    return container;
  }

  static getDefaultTemplateState(stateType: WidgetComponentType): WidgetState {
    return {
      type: stateType,
      containersDirection: 'Horizontal',
      width: stateType === WidgetComponentType.Teaser ? '200px' : '600px',
      height: '48px',
      background: { color: '#ffffff' },
      padding: {
        roundValue: '16px',
      },
      radius: {
        roundValue: '0px',
      },
      shadow: {
        horizontalLength: '8px',
        verticalLength: '8px',
        blur: '12px',
        color: '#00000038',
        spreadRadius: '8px',
      },
      order: 0,
    } as unknown as WidgetState;
  }

  static getCopyOfTemplateState(
    widgetState: WidgetState,
    newStateType: WidgetComponentType,
    order: number,
    position: WidgetPosition,
    brandVarCanvas?,
    widgetLayout?: WidgetLayout,
  ): WidgetState {
    const newWidgetState = {
      padding: widgetState.padding ? widgetState.padding : { roundValue: '16px' },
      background: widgetState.background ? widgetState.background : {},
      margin: widgetState.margin ? widgetState.margin : { roundValue: '0px' },
      radius: widgetState?.radius ? widgetState.radius : brandVarCanvas?.radius ? null : { roundValue: '0px' },
      shadow: widgetState.shadow ? widgetState.shadow : {},
      width: newStateType !== WidgetComponentType.Teaser ? widgetState.width : '200px',
      height: '48px',
      position: position,
      // Keep the source's own layout, otherwise its position ends up paired with the widget layout.
      layout: widgetLayout && widgetState.layout && widgetState.layout !== widgetLayout ? widgetState.layout : undefined,
      type: newStateType,
      order: order,
      widgetId: widgetState.widgetId,
      productTourProperties: widgetState.productTourProperties,
      wcagProperties: widgetState.wcagProperties,
    } as WidgetState;

    return newWidgetState;
  }

  static getDefaultTemplateSettings(): CampaignTemplate {
    const template = {
      name: '',
      nameSwedish: '',
      widgets: [] as Array<Widget>,
    } as CampaignTemplate;

    const newWidget = {
      previewBackgroundColor: '#ffffff',
      order: 0,
    } as Widget;

    const newWidgetState = this.getDefaultTemplateState(WidgetComponentType.Regular);

    newWidget.states = [newWidgetState];
    template.widgets = [newWidget];
    return template;
  }

  public static getIconForTemplatePurpose(purposeTemplateTag: TemplateTag): string {
    switch (purposeTemplateTag.name) {
      case 'Collect subscribers':
        return '/assets/img/campaign/purpose/collect_subscribers2.svg';
      case 'Intelligent greeting':
        return '/assets/img/campaign/purpose/intelligent_greeting.svg';
      case 'Shopping cart recovery':
        return '/assets/img/campaign/purpose/recover_cart.svg';
      case 'Help hestitant buyers':
        return '/assets/img/campaign/purpose/hesitant_buyers2.svg';
      case 'Generate leads':
        return '/assets/img/campaign/purpose/capture_more_leads2.svg';
      case 'Renew consent':
        return '/assets/img/campaign/purpose/renew_consent.svg';
      case 'Embed personalized content':
        return '/assets/img/campaign/purpose/embed_personalized_content.svg';
      case 'Lock content':
        return '/assets/img/campaign/purpose/paywall.svg';
      case 'Catch leaving visitors':
        return '/assets/img/campaign/purpose/exit_intent.svg';
      case 'Promote offer':
        return '/assets/img/campaign/purpose/promote_offers.svg';

      default:
        return '/assets/img/campaign/purpose/intelligent_greeting.svg';
    }
  }
}
